import { OwnedObjectType } from './OwnedObjects';
import { DisplayObject } from '../DisplayObject';
import { Button } from '../Base/Button';
import { executeApiCall } from '../../utils';
import { useSuiClient } from '@mysten/dapp-kit';
import { useEssential } from '../../App';
import { useState } from 'react';
import { LoadingWithContent } from '../Base/Loading';
import { ModalBase } from '../Modals/Base';
import lootboxImage from '../../../assets/scard/lootbox.png';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';
import { TwitterShareButton, XIcon } from 'react-share';
import {
  SUDO_CARD_LOOTBOX_TYPE_SUFFIX,
  SUDO_CARD_LOOTBOX_WITH_AMOUNT_TYPE_SUFFIX,
} from '../../../utils/utils';

export function OwnedObject({ object }: { object: OwnedObjectType }) {
  const suiClient = useSuiClient();
  const { wallet, network, refreshAccount } = useEssential();
  const { width } = useWindowSize();
  const { consts, refetchOwnedObjects } = useEssential();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [lootboxOpenModalResult, setLootboxModalOpenResult] =
    useState<string>('');

  const [slpWinAmount, setSlpWinAmount] = useState<number>(0);

  const openLootbox = (item: OwnedObjectType) => {
    executeApiCall(
      async api => {
        setIsSubmitLoading(true);
        return item.type.includes(SUDO_CARD_LOOTBOX_WITH_AMOUNT_TYPE_SUFFIX)
          ? api.openLootboxWithAmount(item.objectId)
          : api.openLootbox(item.objectId);
      },
      res => {
        setIsSubmitLoading(false);
        if (Number(res.events[0].parsedJson.price_value) > 0) {
          setSlpWinAmount(
            Number(res.events[0].parsedJson.price_value) /
              10 ** consts.coins['slp'].decimals,
          );
          setLootboxModalOpenResult('You have won SLP!');
        } else {
          setLootboxModalOpenResult('Better luck next time');
        }
        const txnUrl = `https://www.suiscan.xyz/${network}/tx/${res?.digest}`;
        return (
          <a href={txnUrl} target="_blank" rel="noreferrer">
            {' '}
            Success send tx: {res?.digest}{' '}
          </a>
        );
      },
      e => {
        console.error(e);
        setIsSubmitLoading(false);
        return `Error: ${e.message}`;
      },
      wallet,
      network,
      suiClient,
      [refreshAccount],
      undefined,
      true,
      true,
    ).finally();
  };

  if (isSubmitLoading)
    return <LoadingWithContent content="Revealing Lootbox..." />;

  const objectDetail = () => {
    if (Object.keys(object.display).length !== 0) {
      return (
        <div>
          {lootboxOpenModalResult === '' && (
            <DisplayObject item={object}>
              <>
                <Button
                  className="bg-primary app-loader-button md:col-span-2"
                  loading={false}
                  onClick={() => {
                    openLootbox(object);
                  }}
                >
                  Reveal Lootbox
                </Button>
              </>
            </DisplayObject>
          )}
          {lootboxOpenModalResult && (
            <ModalBase
              isOpen={lootboxOpenModalResult !== ''}
              size="xl"
              closeModal={() => {
                refetchOwnedObjects();
                setLootboxModalOpenResult('');
                setSlpWinAmount(0);
              }}
              title={lootboxOpenModalResult}
            >
              {lootboxOpenModalResult === 'You have won SLP!' ? (
                <div
                  className={`modal-max-600-container py-5 sm:py-10 sm:px-14 px-5 relative border-primary text-center border-1 popout overflow-hidden`}
                >
                  <Confetti width={width} height={700} />
                  <h1 className="text-xl">
                    {' '}
                    Congratulations! You have won {slpWinAmount} SLP!{' '}
                  </h1>
                  <h1 className="text-xl"> Share the exciting news!</h1>
                  <div className="Demo__some-network">
                    <TwitterShareButton
                      url={'https://app.sudo.finance'}
                      title={`I won ${slpWinAmount} SLP from SLP Lootbox. Get your S Card to win more privileges on @sudofinance!`}
                      className="Demo__some-network__share-button"
                    >
                      <XIcon size={32} round />
                    </TwitterShareButton>
                  </div>
                  <div className="align-center">
                    <img
                      src={lootboxImage}
                      alt="Lootbox"
                      className="overflow-hidden rounded-xl w-1/2 aspect-square ml-auto mr-auto"
                    />
                  </div>
                </div>
              ) : (
                <div
                  className={`modal-max-600-container py-5 sm:py-10 sm:px-14 px-5 relative border-primary border-1 overflow-hidden`}
                >
                  Oops. Better luck next time.
                </div>
              )}
            </ModalBase>
          )}
        </div>
      );
    }
  };

  return objectDetail();
}
